import React from 'react';
import { Outlet } from 'react-router-dom';
import styles from './finance.module.scss';

export default function Finance() {

  return (
    <div className={`${styles.wrapper}`}>
      <Outlet/>
    </div>
  );
}
